import { render } from "./ViewMercadoSuccess.vue?vue&type=template&id=0c8f51f7"
import script from "./ViewMercadoSuccess.vue?vue&type=script&lang=js"
export * from "./ViewMercadoSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__